<template>
  <div class="smartPublicSecurity-layout">
    <!-- <swiper class="swiper" :options="swiperOptions" ref="mySwiper" v-if="pageDataList.length > 0"> -->
    <swiper-slide class="swiper-slideInn">
      <!-- <div
        class="top-layout"
        :style="
          'background:url(' +
          pageData.thumbnail +
          ');background-size: 100% 100%;background-repeat: no-repeat;'
        "
      > -->
      <div
        class="top-layout"
        :style="
          'background:url(https://www.dpark.com.cn/img/indexbg.1ae76b97.jpg);background-size: 100% 100%;background-repeat: no-repeat;'
        "
      >
        <img
          src="@/assets/img/childrenpage/smartPublicSecurity/moban1.svg"
          class="moban1"
        />
        <div class="moban2">
          <borderUpdateCom btnText="主标题编辑" componentsName="IndexEditCase">
            <div class="title">{{ pageData.title }}</div>
          </borderUpdateCom>
          <borderUpdateCom btnText="区域编辑" componentsName="AddressEditCase">
            <div class="sban-list">所属区域>{{ pageData.address }}</div>
          </borderUpdateCom>
        </div>
      </div>
      <!-- 案例简介-->
      <div class="content">
        <TitleCom text="案例简介" />
        <div class="content-layout">
          <div class="typeLsit">
            <borderUpdateCom btnText="案例标签编辑" componentsName="LabelEditCase">
              <div class="kind" v-for="label in showlist" :key="label">{{ label }}</div>
            </borderUpdateCom>
            <borderUpdateCom btnText="内容编辑" componentsName="ContentEditCase">
              <div
                class="html-content swiper-no-swiping"
                v-html="pageData.content"
              ></div>
            </borderUpdateCom>
          </div>
          <borderUpdateCom btnText="图片编辑" componentsName="ImageEditCase">
            <img :src="pageData.thumbnail" class="sevice-img" />
          </borderUpdateCom>
        </div>
      </div>
    </swiper-slide>
    <!-- 案例亮点1-->
    <swiper-slide
      class="swiper-slideInn"
      v-show="
        pageDataList[0] && (pageDataList[0].moduleList.length > 0 || $store.state.editStatus === 0)
      "
    >
      <div class="painpoint">
        <borderUpdateCom btnText="编辑数量" componentsName="LightPointListCase" :caseIndex="0">
          <div class="painpoint-content">
            <borderUpdateCom btnText="标题编辑" componentsName="TitleEditCase" :caseIndex="0">
              <TitleCom :text="pageDataList[0].title" class="titlePosition" />
            </borderUpdateCom>
            <div class="painpoint-list">
              <div
                v-for="(i, index) in pageDataList[0].moduleList"
                :key="index"
              >
                <borderUpdateCom
                  btnText="编辑"
                  :caseIndex="0"
                  :indexs="index"
                  :nowNumber="1"
                  componentsName="LightPointCase"
                >
                  <div
                    class="painpoint-item"
                    :class="
                      PgetainpointClass(pageDataList[0].moduleList.length)
                    "
                  >
                    <div class="iconlogo">
                      <img
                        :src="
                          i.imgUrl == baseImg
                            ? require('@/assets/img/childrenpage/smartPublicSecurity/tdbase.png')
                            : i.imgUrl
                        "
                        class="neicon"
                      />
                    </div>
                    <div class="painpoint-title">{{ i.chtitle }}</div>
                    <div class="painpoint-text">{{ i.content }}</div>
                  </div>
                </borderUpdateCom>
              </div>
            </div>
          </div>
        </borderUpdateCom>
      </div>
    </swiper-slide>
    <!-- 案例亮点2-->
    <swiper-slide
      class="swiper-slideInn"
      v-show="
        pageDataList[1] && (pageDataList[1].moduleList.length > 0 || $store.state.editStatus === 0)
      "
    >
      <div class="coreValues">
        <div class="coreValues-content">
          <borderUpdateCom btnText="标题编辑" componentsName="TitleEditCase" :caseIndex="1">
            <TitleCom :text="pageDataList[1].title" />
          </borderUpdateCom>
          <borderUpdateCom btnText="编辑数量" componentsName="LightPointListCase" :caseIndex="1">
            <div class="coreValues-list">
              <div
                v-for="(i, index) in pageDataList[1].moduleList"
                :key="index"
              >
                <borderUpdateCom
                  btnText="编辑"
                  :caseIndex="1"
                  :indexs="index"
                  :nowNumber="2"
                  componentsName="LightPointCase"
                >
                  <div
                    class="coreValues-item"
                    :class="getValuesClass(pageDataList[1].moduleList.length)"
                  >
                    <img :src="i.imgUrl" class="itemicon" />
                    <div class="coreValues-bottom">
                      <div class="coreValues-title">{{ i.chtitle }}</div>
                    </div>
                  </div>
                </borderUpdateCom>
              </div>
            </div>
          </borderUpdateCom>
        </div>
      </div>
    </swiper-slide>
    <!-- </swiper> -->
  </div>
</template>

<script>
import TitleCom from "./components/titleCom.vue";
import borderUpdateCom from "./components/borderUpdateCom.vue";
import { getClassicCaseByid, addClassicCase } from "@/api/case.js";
import { baseJSON } from "./baseCase";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "smartPublicSecurity",
  components: {
    TitleCom,
    swiperSlide,
    swiper,
    borderUpdateCom,
  },
  data() {
    return {
      dialogVisible: false,
      pageData: {}, // 当前页面数据
      pageDataList: [], //当前也数据列表
      saveData: {},
      baseImg: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAABACAYAAABC6cT1AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAVZSURBVGhD7Zv9bxRFGMfvD1JjosbE4EuIP0BiTMQYftBEif5iYmKICmpERSOCGHyJVaOhGEUQFapREpJiFMWmSAiCWoUCba8gL22F9K5Xjmv7uN/rTfvs7MzNy+5cD9dv8m0DO7vzfDr7Ms8zuwXKqf4Hz5uCgw+NEPUcI/rqINHH+4je7ybq2DP7G//G/2M72rVSmYP39hO9uZvowQ6iG58muuYJe6M99sP+OE5IZQLed5ro1S6i219QA/kax8NxcfyslQr8QDQqj21WB5210Q/6y0pe4MNjRKu2qgMMbfSL/tPKGXzbfqLrV6mDapXRP+JII2vwy1cWbpR1RjyIy0dW4IMXiO7bpO58oY24Bs43AnWQEfzoENHil9SdtosRH+J0UVNwHGzRGnVn7WbE6QKvBcfp0+4jLRvx2p72SnDcMNr1mjYZcVdrDZAmUoK3293b1YjfpAQ4no/ygW55boa2/zhJZ0dKND4+bvSRk2Xa2TNJK7fU6OZnZ2hFR41e66rS0NnZ/YvnSrTnUIXW76rSDatnEv1lYdNzPgY+PKqenHy+fzIBZ+vvj0xEN55ZOPwRvvmlEtveP1yi5W9MJfpMa3CAR6cYuO4UPz9qN9I6HyuWafHa+ZHt3Hs50eaR92qxPrPw6k8bYArNgSMBUO0My0H6uG+wHGVb8/AffRc/i8YuhoHXJTZz4M2yLB6g8O6DFXq8s0Zrtl+hQ8fLyjay/5DgO/cmL6Gs4cGlUh28b1i9k7AcHG5cfPt1TxEd7reDN438yD/j9NA72V7z4JNVB0eyr9pBmAcGP/B2MrC1O6qJdjrL8Nv2hYUHn6w6+B0vqncQ5kHB97+VDhzm8Nc+GRYefLIKqG2pGnPzgOAvoscb3+5yqnO3El6u4RVQ2FM15ObBCPvc3FT+fSB+2n/yQ/KGlwU8OLkKqGqqGnLLgWRtjPyi58OOPDi5CjYlYB5EKP92qky3NuDhrdLIj4ylg7/pmQZxQwVVI9nFxhw7tAFvGnnVjdXWRTaFtQLvPhyfX4e0Gb7kDY8VGyErcNzAeOehfTTK7gQ8vOOn5GmvmkuYjOUqIStwGFkU7zy0ZfjPorSYb/cZeazVCVmDL31lmgb/bi088noOL6fHGHkXeCxUClmDw0vXTdeLCLzz0P71RDkWw7dSPg/4ZRunY210xiqtkBM4fNf61sOv21md6x+THXk7ih08Rp29R1z47g3TdOZC6+B39VRi/Z88He/73Ggptl1nr2tc9j3R6WVbg0vrrEbc666u8r2vTwWHt7nGMQi8jc7Oz/FmXrZxKnVNTmd5MvPlz+lmcrGZG+awqkYuXr5pqv5c5UGlddaJS2KubpOd2Rh/+azgQ+TpiezMJh+39Sx8HMLVx4vNoVGN9cnSEvm4TQXGxQjKFx7QvP6ugvatwiYqMPhhqrm5GvAIkgdtsgwtV18vXvKHVtbc8MNUZfUxgkSwPHidT0QTEhP0ox/419u1VVZTXd3XCNYED+g7X55/DmcNDWvr6lCo99UQ9CUN/ECU7XHoD7vja2rYLy1005UUqNnaWVpjuZgDwafOlGhJlOqKNhu6knV5VHH5cXxsXDuDsLqo2jkLP/xujQ78NVFPKL7urcRGGr4teoT1/jlRB+7pm6AVHe6PLNlWq6WQbn38arTT+jikeiPiarTTGxFCuXwHBsJbQ7l86wnK5XtuQrl8s1EIB2v3kUd8LtCQERzC6dOu1zzisj29uazAoVy+r86F5+NCT3LQv+k5bZIzOJTLb1K4kACEyupkox9dwuGjVOBCufvuTCXUtlDYQ1XzP/+lYTOpvi0F5MJ+W0r0L9m9Vfq7xsa5AAAAAElFTkSuQmCC',
      downTime: 0,
      CaseId: "",
      showlist: [],
    };
  },
  watch: {
    "$store.state.changeRefresh"() {
      this.getData();
    },
    "$route.query.data": {
      handler: function (val) {
        this.getData();
      },
      deep: true,
    },
  },
  mounted() {
    this.CaseId = this.$route.query.CaseId;
    // 判断是否创建了该典型案例
    if (this.CaseId) {
      this.getData();
    } else {
      this.saveBaseData();
    }
  },
  methods: {
    openwindow() {
      this.dialogVisible = true;
    },
    //核心价值classs
    getValuesClass(size) {
      let classString = "";
      switch (size) {
        case 1:
          classString = "valueModel1";
          break;
        case 2:
          classString = "valueModel2";
          break;
        case 3:
          classString = "valueModel3";
          break;
        case 4:
          classString = "valueModel4";
          break;
        case 5:
          classString = "valueModel5";
          break;
        case 6:
          classString = "valueModel5";
          break;
      }
      return classString;
    },
    //痛点分析
    PgetainpointClass(size) {
      let classString = "";
      switch (size) {
        case 1:
          classString = "valueModel1";
          break;
        case 2:
          classString = "valueModel2";
          break;
        case 3:
          classString = "valueModel3";
          break;
        case 4:
          classString = "valueModel4";
          break;
        case 5:
          classString = "valueModel5";
          break;
        case 6:
          classString = "valueModel5";
          break;
      }
      return classString;
    },
    getData() {
      getClassicCaseByid(this.CaseId).then((res) => {
        if (res.code == 200) {
          if (!res.data.childrens) {
            this.saveBaseData(res.data);
          } else {
            this.$store.commit("saveProProgrammeId", res.data.id);
            this.$store.commit(
              "savePageTemplateData",
              JSON.parse(JSON.stringify(res.data))
            );
            this.showlist = res.data.label.split(';');
            if(res.data.labelMore) {
              let arr = res.data.labelMore.split(';');
              this.showlist = this.showlist.concat(arr).filter(val => {
                // 去除空字符串''
                return val && val.trim()
              })
            }
            this.pageData = res.data;
            this.pageDataList = JSON.parse(res.data.childrens);
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //保存初始数据
    saveBaseData(data) {
      let customDetailList = JSON.stringify(baseJSON);
      let param = {}
      if (data) {
        param = {...data}
      } else {
        param = {
          title: "案例标题",
          thumbnail: require("@/assets/img/childrenpage/smartPublicSecurity/serviceimg.jpg"),
          address: "江苏",
          label: "测绘服务",
          content:
            "自2009年以来，园测信科一直致力于扶持公安项目的发展，为社会治安提供有力保障。项目涵盖了多个领域，包括信息化建设、重点安保区域的安保力量升级、交警静态设施动态管理、一体化孪生系统，信号控制系统、特殊场景实战指挥系统等。" +
            "在技术支持方面，我司为公安部门提供7x24小时的技术支持服务，确保公安系统的正常运行。同时，我们还积极参与公安部门的科技创新项目，推动公安事业的现代化发展。" +
            "园测信科一直关注公安事业的发展，致力于为公安部门提供全方位的支持。我们将继续努力，为构建和谐安全的社会环境贡献自己的力量。",
          isRelease: 0,
          highlights: "[]",
        };
      }
      param.childrens = customDetailList
      addClassicCase(param).then((res) => {
        if (res.code == 200) {
          this.CaseId = res.data;
          setTimeout(() => {
            this.getData();
          },300)
        }
      });
    },
  },
};
</script>
<style  lang="scss" scoped>
.subForm {
  text-align: center;
  width: 100%;
  display: inline-block;
  margin: 0 auto;
}
.smartPublicSecurity-layout {
  // background: rgba(233, 235, 239, 1);
  width: 100%;
  height: 100%;

  // margin-top: 60px;
  .swiper {
    height: 100vh;
  }

  /* 顶部样式 */
  .top-layout {
    width: 100vw;
    height: 40vh;
    background: require('@/assets/img/childrenpage/smartPublicSecurity/indexbg.jpg');
    display: flex;
    justify-content: center;
    position: relative;

    .moban1 {
      width: 100%;
      height: 100%;

      // margin-bottom: -20px;
    }

    .moban2 {
      background: url("../../../../assets/img/childrenpage/smartPublicSecurity/moban3.svg");
      background-size: 100% 100%;
      width: 100%;
      height: 166px;
      position: absolute;
      // z-index: 100;
      z-index: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .title {
        font-family: "PingFangSC-Semibold", "PingFang SC Semibold",
          "PingFang SC ExtraLight", "PingFang SC", sans-serif;
        font-weight: 650;
        font-style: normal;
        font-size: 38px;
        color: #ffffff;
      }

      .sban-list {
        font-family: "PingFang-SC-ExtraLight", "PingFang SC ExtraLight",
          "PingFang SC", sans-serif;
        font-weight: 400;
        font-style: normal;
        color: #ffffff;
        margin-top: 35px;
      }
    }
  }

  /* 案例简介 */
  .content {
    padding: 8vh 15vw 10vh 15vw;
    .title-style {
      width: 120px;
      margin: 0 auto;
    }

    // background-image: url('../../../../assets/img/childrenpage/smartPublicSecurity/corebg.jpg');
    // background-size: 100% 100%;
    .content-layout {
      display: flex;
      justify-content: space-between;
      margin-top: 3vh;

      .html-content {
        width: 25vw;
        font-size: 14px;
        line-height: 30px;
      }

      .sevice-img {
        width: 32vw;
        height: 32vh;
      }
    }
  }

  /* 痛点分析 */
  .painpoint {
    width: 100%;
    height: 100vh;
    // background: rgba(233, 235, 239, 1);
    display: flex;
    background-image: url("../../../../assets/img/childrenpage/smartPublicSecurity/corebg.jpg");
    background-size: 100% 100%;
    justify-content: center;
    align-items: center;
    margin-top: 3vh;

    .painpoint-content {
      // margin: 0 auto;
      background: #ffffff60;
      width: 83vw;
      height: 72vh;
      padding: 5vh 2vw 5vh 2vw;
      .titlePosition {
        // margin-left: 350px;
      }
      .painpoint-list {
        width: 100%;
        height: 72vh;

        // height: 650px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 30px;

        .valueModel1 {
          // width: 1303px !important;
          width: 803px !important;
          height: 350px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .valueModel2 {
          // width: 1303px !important;
          width: 803px !important;
          height: 256px !important;
          display: flex;
          flex-direction: column;
          align-items: center;

          // padding-top: 10px;
          .painpoint-text {
            height: 120px !important;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
          }
        }

        .valueModel3 {
          width: 563px !important;
          height: 306px !important;
          display: flex;
          flex-direction: column;
          align-items: center;
          .painpoint-text {
            height: 386px !important;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 13;
            overflow: hidden;
          }
        }

        .valueModel4 {
          width: 563px !important;
          // height: 206px !important;
          height: 286px !important;

          .painpoint-text {
            height: 120px !important;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
          }
        }

        .valueModel5 {
          width: 380px !important;
          height: 246px !important;

          .painpoint-text {
            height: 120px !important;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
          }
        }

        .painpoint-item {
          width: 328px;
          // max-height: 260px;
          // margin-top: 55px;
          margin-top: 2vh;
          margin-left: 50px;
          margin-right: 50px;

          // height: 206px;
          // width: 663px;
          // overflow: hidden;
          .painpoint-title {
            font-family: "PingFangSC-Semibold", "PingFang SC Semibold",
              "PingFang SC ExtraLight", "PingFang SC", sans-serif;
            font-weight: 650;
            font-style: normal;
            font-size: 22px;
            margin-top: 10px;
          }

          .painpoint-text {
            font-family: "PingFang-SC-ExtraLight", "PingFang SC ExtraLight",
              "PingFang SC", sans-serif;
            font-weight: 400;
            font-style: normal;
            font-size: 14px;
            line-height: 30px;
            margin-top: 10px;
          }

          .iconlogo {
            width: 61px;
            height: 61px;
            // background: url('../../../../assets/img/childrenpage/smartPublicSecurity/iconbg1.svg');
            // background-size: 100% 100%;
            // background-repeat: no-repeat;
            text-align: center;
            line-height: 80px;

            .neicon {
              width: 61px;
              height: 61px;
            }
          }
        }
      }
    }
  }

  /* 案例亮点2 */
  .coreValues {
    width: 100vw;
    height: 100vh;
    background: url("../../../../assets/img/childrenpage/smartPublicSecurity/corebg.jpg");
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .coreValues-content {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      flex-direction: column;
      top: 10vh;

      .coreValues-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        width: 100vw;
        min-height: 30vh;

        .valueModel1 {
          width: 1203px !important;
          height: 456px !important;
          position: relative;
          top: 60px;
        }

        .valueModel2 {
          width: 1203px !important;
          height: 306px !important;
          position: relative;
          top: 10px;
        }

        .valueModel3 {
          width: 1203px !important;
          height: 216px !important;
        }

        .valueModel4 {
          width: 700px !important;
          height: 340px !important;
          position: relative;
          top: 10px;
        }

        .valueModel5 {
          width: 500px !important;
          height: 350px !important;
        }

        .sizewidthitem {
          width: 893px !important;
          height: 206px;
        }

        .coreValues-item {
          height: 206px;
          width: 663px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          margin-top: 4vh;
          margin-left: 20px;
          margin-right: 20px;
          padding-right: 30px;
          position: relative;

          .itemicon {
            border-radius: 10px;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
          }

          .coreValues-bottom {
            position: absolute;
            bottom: 0;
            right: 0;
            width: 100%;
            background: linear-gradient(45deg,#d0e2f8 0%, #82b6ee 70%);
            color: #fff;
            height: 20%;
            display: flex;
            justify-content: space-around;
            align-items: center;
            .coreValues-title {
              font-family: "PingFangSC-Semibold", "PingFang SC Semibold",
                "PingFang SC ExtraLight", "PingFang SC", sans-serif;
              font-weight: 650;
              line-height: 100%;
              font-style: normal;
              font-size: 18px;
            }
          }
        }
      }
    }
  }

}

.bannerchange {
  // background: rgba(47, 147, 247, 0.8);
  position: absolute;
  // top: 60px;
  width: 100%;
  height: calc(22vh + 2px);
}

.topbanner {
  margin-top: 60px;
}

.titlefont {
  font-size: 60px;
  font-weight: bold;
}

.sendStyle {
  color: white;
  font-size: 20px;
  background-color: #3564f2;
  border-radius: 60px;
  border: none;
  width: 150px;
  height: 60px;
  cursor: pointer;
}

// .swiper-slide {
//   z-index: 2000;
// }
.typeLsit {
  width: 500px;
  ::v-deep .centerslot {
    justify-content: left;
    flex-wrap: wrap;
  }
  .kind {
    background: #fcfffe;
    border: 1px solid #003889;
    border-radius: 2px;
    margin: 0 20px 10px 0;
    padding: 5px 20px;
    font-size: 16px;
    font-weight: 400;
    color: #003889;
  }
}
</style>

<style lang="scss">
.demo-ruleForm {
  .el-input-group__append {
    background-color: #409eff;
    color: #fff;
    cursor: pointer;
  }
}
</style>